
import { defineComponent, onMounted, ref } from "vue";
import Header from "./components/Header.vue";
import { FAQ_LIST } from "./constants/FAQ_LIST";
import CategoryVue from "./components/Category.vue";
export default defineComponent({
	name: "App",
	components: {
		Header,
		CategoryVue,
	},
	setup: () => {
		const headerHeight = ref(0);
		const hash = location.hash?.replace("#", "") || "";
		const [categoryKey, question] = hash.includes("/")
			? hash.split("/")
			: [hash, undefined];
		const questionKey = ref<string>();

		onMounted(() => (questionKey.value = question));

		return {
			FAQ_LIST,
			headerHeight,
			categoryKey,
			questionKey,
			setHeaderHeight: (height: number) => (headerHeight.value = height),
		};
	},
});
